// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SimpleIntakePatientPhonesModel {
    static getAttributeTypeMap() {
        return SimpleIntakePatientPhonesModel.attributeTypeMap;
    }
}
SimpleIntakePatientPhonesModel.discriminator = undefined;
SimpleIntakePatientPhonesModel.additionalProperties = false;
SimpleIntakePatientPhonesModel.attributeTypeMap = [
    {
        "name": "home",
        "baseName": "home",
        "type": "SimpleIntakePhoneModel"
    },
    {
        "name": "mobile",
        "baseName": "mobile",
        "type": "SimpleIntakePhoneModel"
    },
    {
        "name": "work",
        "baseName": "work",
        "type": "SimpleIntakePhoneModel"
    },
];
//# sourceMappingURL=simpleIntakePatientPhonesModel.js.map